import { api } from '../api';
import {
  GET_USER_KYC_INFO,
  UPLOAD_IDENTITY_PIC,
  UPLOAD_SELFIE,
  SUBMIT_KYC,
  UPDATE_ADDRESS,
  SUBMIT_NATIONALID,
  UPLOAD_IDENTITY_CARD,
  IS_REQUIRED_OPTIONAL_IDENTITY
} from '../../constants';
import {
  kycBriefResponse,
  kycIdentityPicResponse,
  kycNationalIdRequest,
  kycNationalIdResponse,
  updateAddressRequest
} from './types';

const kycSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getUserKycInfo: build.query<kycBriefResponse, void>({
      query: () => GET_USER_KYC_INFO,
      providesTags: ['BasicInfo']
    }),
    getIsRequired: build.query<{ is_required: boolean }, void>({
      query: () => IS_REQUIRED_OPTIONAL_IDENTITY
    }),
    uploadIdentityCard: build.mutation<{}, FormData>({
      query(data) {
        return {
          url: UPLOAD_IDENTITY_CARD, // Add this constant
          method: 'POST',
          body: data
        };
      },
      invalidatesTags: ['BasicInfo']
    }),
    uploadIdentity: build.mutation<{}, FormData>({
      query(data) {
        return {
          url: UPLOAD_IDENTITY_PIC,
          method: 'POST',
          body: data
        };
      }
    }),
    uploadSelfie: build.mutation<{}, FormData>({
      query(data) {
        return {
          url: UPLOAD_SELFIE,
          method: 'POST',
          body: data
        };
      }
    }),
    submitNationalId: build.mutation<
      kycNationalIdResponse,
      kycNationalIdRequest
    >({
      query(data) {
        return {
          url: SUBMIT_NATIONALID,
          method: 'POST',
          body: data
        };
      }
    }),
    updateAddress: build.mutation<kycBriefResponse, updateAddressRequest>({
      query(data) {
        return {
          url: UPDATE_ADDRESS,
          method: 'POST',
          body: data
        };
      }
    }),
    submitKyc: build.mutation<kycBriefResponse, string>({
      query(name) {
        return {
          url: `${SUBMIT_KYC}/${name}`,
          method: 'GET'
        };
      },
      invalidatesTags: ['BasicInfo']
    })
  }),
  overrideExisting: false
});

export const {
  useGetUserKycInfoQuery,
  useLazyGetUserKycInfoQuery,
  useUploadIdentityMutation,
  useUploadIdentityCardMutation,
  useUploadSelfieMutation,
  useSubmitKycMutation,
  useUpdateAddressMutation,
  useSubmitNationalIdMutation,
  useGetIsRequiredQuery
} = kycSlice;
